import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const Container = styled.div`
  background-color:#EBEBEE;
  height:100%;
  user-select: none; 
  margin-top:10px;
  overflow:scroll
  
`; 
export const BoxContainer = styled.div`
  background-color:#FFFFFF;
  height:35%;
  max-height:auto;
  width:96%;
  user-select: none; 
  margin-top:1%;
  border-radius:20px;
  display:flex;
  flex-direction:row ;
  

`;
export const Box1 = styled.div`
  
  min-height:40%;
  max-height:auto;
  width:55%; 
  
  margin-left:7px;
  margin-right:10px;
  border-radius:20px;
  display:flex;
  flex-direction:row ;
  flex-wrap: wrap;

`;
export const ImageBox = styled.div`
  
  text-align:center;
  width:40%;
  
  padding-right:50px
  
  
`;
export const CircleBox = styled.div`
  background-color:#EBEBEE;
  width: 151px;
  height:  151px;
  user-select: none; 
  margin-top:5%;
  margin-left:5%;
  border-radius:50%;
  display:flex;
  flex-direction: column;

   
`;
export const CustomerCareImge = styled.img`  
width: 100%; 
height: 90%; 
display: block; 
margin-top:10px;
margin-bottom:10px
object-fit: cover; 
`;
export const CircleItem = styled.div`   
  text-align:center;
  color:#000000;
  font-family: var(--font-product-sans);
  margin:auto;
  font-weight:700;
  font-size:15px ;
  padding-top:20px;
  
  `;
  export const CircleImg = styled.img`   
  text-align:center;
  color:#000000;
  font-family: var(--font-product-sans);
  margin:auto;
  margin-top: -20px;
  `;

export const Fields=styled.div` 
padding:10px; 
display:flex;
flex-wrap:wrap;
padding-left:40px;  
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */ 
height:297px;

`;

export const FieldContainer=styled.div`

width: 46%;
flex-shrink: 0;
border-radius: 12px; 
display:flex;
flex-direction:row;
text-align:center;

animation: ${fadeIn} 1s ease-in-out forwards; 

`;


export const FieldTextAreaContainer=styled.div`

width: 100%;
height: 72px;
flex-shrink: 0;
border-radius: 12px;

display:flex;
flex-direction:row;
text-align:center;

animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;



export const FieldLabel=styled.div`

`

export const Input = styled.input`
cursor:pointer;
margin-left: 24px;
padding: 10px; 
border-radius: 10px;
border:none;
background: #EBEBEE;
width: 70%;
height: 25px;
flex-shrink: 0;
outline:none;
font-size:16px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 96%;
  margin-top:10px;
  
  animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
  background: #FFF;
  border-radius:20px;
  margin-bottom:100px;

`;
export const Header = styled.div`
  
color: #000;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
padding-top:10px;
padding-left:10px;

`;


export const InputTextArea = styled.textarea`
cursor:pointer;
margin: 14px;
padding: 10px;  
border-radius: 10px;
border:none;
background: #EBEBEE;
width: 80%;
height: 50px;
flex-shrink: 0;
outline:none;
font-size:16px;
`; 

export const SubmitButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  border-radius: var(--br-5xs);
  background-color: rgb(66, 133, 244);
  width: 146px;
  height: 29px;
  font-weight:bold;
  color: var(--color-white);
  font-family: var(--font-product-sans);
  cursor: pointer;
  ` 
  export const ButtonSection = styled.div`
  width:89%;
  display: flex;
  flex-direction: row;
  justify-content: center; /* Horizontally center the inner element */
  align-items: center; /* Vertically center the inner element */
  animation: ${fadeIn} 1s ease-in-out forwards; 
 `